import { render, staticRenderFns } from "./narcoticReportingC2G.vue?vue&type=template&id=81e85a54"
import script from "./narcoticReportingC2G.vue?vue&type=script&lang=js"
export * from "./narcoticReportingC2G.vue?vue&type=script&lang=js"
import style1 from "./narcoticReportingC2G.vue?vue&type=style&index=1&id=81e85a54&prod&lang=css"
import style2 from "./narcoticReportingC2G.vue?vue&type=style&index=2&id=81e85a54&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports